import gql from 'graphql-tag';
import { ENTITY } from '../entities';
import { GoodPatchMutation } from '../../graphql/mutations/GoodPatchMutation';
import { GoodEditQuery } from '../../graphql/query/GoodEditQuery';
import GoodIntro from '../../static/introspection/Good.json';
import GoodPatchIntro from '../../static/introspection/GoodPatchInput.json';
import {
	ConnectedEntityConfig,
	ConnectedRef,
	EditSectionKey,
} from './companyData360';

/**
 * Configurazione per la modifica dei dati del Good collegato ad un Good360, usata dalle
 * sezioni di tipo `edit` del dialogo "Dati e relazioni". Riusa la stessa forma di
 * ConnectedEntityConfig (e quindi lo stesso motore generico di EntityEditFetcher) che usa
 * Company360, ma i dati specifici del prodotto vivono qui, separati da companyData360.
 *
 * NB: un Good360 NON crea il prodotto — il Good esiste già. Qui si modificano solo i dati del
 * Good esistente (goodPatch). Vengono inclusi solo i campi presenti in GoodPatchInput.
 */

// Campi del Good modificabili dalla scheda Good360 (tutti presenti in GoodPatchInput).
const GOOD_INFO_FIELDS = [
	'Brand',
	'GoodClass',
	'featuredImageMedia',
	'featuredImageItaMedia',
	'ingredientsImageMedia',
	'ingredientsImageItaMedia',
	'shelfLifeLength',
	'description',
	'descriptionIta',
	'descriptionLong',
	'descriptionLongIta',
];

export const GOOD_CONNECTED_CONFIG: ConnectedEntityConfig = {
	entityName: ENTITY.GOOD,
	editQuery: GoodEditQuery,
	patchMutation: GoodPatchMutation,
	typeIntro: GoodIntro,
	patchInputIntro: GoodPatchIntro,
	infoFields: GOOD_INFO_FIELDS,
	sedeFields: [],
	companyYearFkField: '',
	hasFairAndCertifications: false,
};

// Il Good360 ha una sola sezione edit: le informazioni del prodotto.
export const GOOD_EDIT_SECTION_KEYS: EditSectionKey[] = ['info'];

/** L'entità collegata di un Good360 è sempre il suo Good. */
export const getGoodConnectedRef = (good360: any): ConnectedRef | null => {
	const good = good360 && good360.Good;
	if (good && good.id) {
		return { config: GOOD_CONNECTED_CONFIG, entityName: ENTITY.GOOD, id: good.id };
	}
	return null;
};

/** Riepilogo leggero del Good per il testo della card della sezione. */
export const buildGoodSummaryQuery = () => gql`
	query GoodData360Summary($id: ID!) {
		entity: node(id: $id) {
			id
			... on Good {
				name
			}
		}
	}
`;